import React, { useEffect } from 'react';
import { graphql, StaticQuery } from 'gatsby';
import { useInView } from 'react-intersection-observer';
import {
  Wrapper,
  HtmlContent,
  MixedLink,
  CaptionedPhoto,
  Image,
  Shape,
} from '../common';
import { convertColorToHex } from '../../util/helpers';
import './WhatWeDoBlock.scss';

const WhatWeDoBlockTemplate = (props) => {
  const {
    data,
    illustrations,
  } = props;
  const {
    etchedScissors,
    etchedPoms,
  } = illustrations;
  const {
    primary,
  } = data;
  const {
    sectionTheme,
    title,
    textBody,
    link,
    linkLabel,
    imageLeft,
    imageLeftCaption,
    imageLeftFrameColour,
    imageRight,
    imageRightCaption,
    imageRightFrameColour,
  } = primary;
  const sectionHex = sectionTheme ? convertColorToHex(sectionTheme) : null;
  const [ref, inView] = useInView({
    /* Optional options */
    threshold: 0.2,
  });
  useEffect(() => {
    if (inView) document.documentElement.style.setProperty('--bg-colour', sectionHex);
  }, [inView]);
  return (
    <section className="what-we-do-block" ref={ref}>
      <Wrapper isBound>
        <div className="illustration-group illustrations-top">
          <div className="illustration illustration-poms">
            <Image
              image={{ localFile: etchedPoms }}
              className="contain"
            />
          </div>
          <div className="illustration illustration-scissors">
            <Image
              image={{ localFile: etchedScissors }}
              className="contain"
            />
          </div>
        </div>
        <div className="cols">
          <div className="col text-col">
            <div className="text-container">
              <h2 className="title">{title.text}</h2>
              <HtmlContent
                className="description"
                content={textBody.html}
              />
              <MixedLink
                buttonLink={link}
                buttonLabel={linkLabel}
                className="more-button styled-button"
              />
            </div>
          </div>
          <div className="col photo-col photo-col-left">
            <CaptionedPhoto
              photo={imageLeft}
              photoCaption={imageLeftCaption.text}
              hasFrame
              frameColour={imageLeftFrameColour}
            />
          </div>
          <div className="col photo-col photo-col-right">
            <CaptionedPhoto
              photo={imageRight}
              photoCaption={imageRightCaption.text}
              hasFrame
              frameColour={imageRightFrameColour}
            />
          </div>
        </div>
        <div className="shapes">
          <Shape
            shapeName="vessel"
            shapeColour="#FF7636"
          />
          <Shape
            shapeName="circle"
            shapeColour="#02701F"
          />
          <Shape
            shapeName="flower"
            shapeColour="#FF6AB8"
          />
        </div>
      </Wrapper>
    </section>
  );
};

const WhatWeDoBlock = props => (
  <StaticQuery
    query={graphql`
      query {
        etchedScissors: file(relativePath: { eq: "assets/images/etched/ETCH_SCISSORS.PNG" }) {
          childImageSharp {
            fluid(maxWidth: 1000 quality: 100) {
              ...GatsbyImageSharpFluid_withWebp_noBase64
            }
          }
        }
        etchedPoms: file(relativePath: { eq: "assets/images/etched/ETCH_POMS.PNG" }) {
          childImageSharp {
            fluid(maxWidth: 1000 quality: 100) {
              ...GatsbyImageSharpFluid_withWebp_noBase64
            }
          }
        }
      }
    `}
    render={data => <WhatWeDoBlockTemplate illustrations={data} {...props} />}
  />
);

export default WhatWeDoBlock;
